import { useEffect, useState } from "react";
import FleetcomService from "../../../services/resource/fleetcomService";
import Chart from 'react-apexcharts';
import ResumoCard from "../../bp/dashboards/ResumoCard";
import { TabelaVeiculos } from "./TabelaVeiculo";
import { Loading } from "../../../componentes/loading/loading";
import { Dialog } from 'primereact/dialog'

function RelatorioFrota() {
    const service = new FleetcomService();

    const [relatorio, setRelatorio] = useState({});
    const [loading, setLoading] = useState(false);
    const [modalAberto, setModalAberto] = useState(false);
    const [filtro, setFiltro] = useState(null);

    useEffect(() => {
        setLoading(true);
        service.relatorioFrota().then(res => setRelatorio(res.data)).finally(() => setLoading(false));
    }, []);

    if (!relatorio) {
        return <div className="p-6">Carregando relatório...</div>;
    }

    const filial = mapToSeries(relatorio.porFilial);
    const tipo = mapToSeries(relatorio.porTipo);
    const fabricante = mapToSeries(relatorio.porFabricante);
    const centroCusto = mapToSeries(relatorio.porCentroCusto);
    const idade = mapToSeries(relatorio.porIdade);

    const porcentagemVeiculosKm = (relatorio.totalVeiculosComKmAlto * 100) / relatorio.totalVeiculos;
    const porcentagemVeiculosVelhos = (relatorio.totalVeiculosComCincoAnos * 100) / relatorio.totalVeiculos;

    function abrirModal(tipo, valor, extra) {
        setFiltro({
            tipo,    
            valor,    
            extra     
        });
        setModalAberto(true);
    }

    function filtrarVeiculos(veiculos, filtro) {
        if (!filtro) return veiculos;

        return veiculos.filter(v => {
            if (filtro.tipo === "filial") return v.filial === filtro.valor;
            if (filtro.tipo === "tipo") return v.tipo === filtro.valor;
            if (filtro.tipo === "fabricante") return v.fabricante === filtro.valor;

            if (filtro.tipo === "idade") {
                const idade = new Date().getFullYear() - filtro.valor;
                return v.anoFabricacao === idade
            }

            if (filtro.tipo === "faixaEtariaFilial") {
                const idade = new Date().getFullYear() - v.anoFabricacao;

                const faixaOk =
                    (filtro.extra === "0-2" && idade <= 2) ||
                    (filtro.extra === "3-5" && idade >= 3 && idade <= 5) ||
                    (filtro.extra === "6-10" && idade >= 6 && idade <= 10) ||
                    (filtro.extra === "10+" && idade > 10);

                return v.filial === filtro.valor && faixaOk;
            }

            return true;
        });
    }

    return (
        <div className="p-6 space-y-6">

            {/* 🔢 Cards */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-2">
                <ResumoCard
                    titulo="Total de Veículos"
                    valor={relatorio.totalVeiculos}
                    isLoading={loading}
                    icone="fa fa-truck"
                    cor="bg-primary"
                    progresso={100}
                    descricao="Total Cadastrado no Fleetcom"
                />
                <ResumoCard
                    titulo="KM Médio"
                    valor={`${relatorio.kmMedio?.toFixed(0) || 0} km`}
                    icone="fa fa-road"
                    isLoading={loading}
                    cor="bg-success"
                    descricao="Média de Km entre todos os veículos"
                    progresso={100}
                />
                <ResumoCard
                    titulo="Veículos com + 500 mil KM"
                    valor={relatorio.totalVeiculosComKmAlto || 0}
                    icone="fa fa-exclamation-triangle"
                    cor="bg-yellow-500"
                    descricao={`Porcentagem da Frota`}
                    isLoading={loading}
                    valorDescricao={porcentagemVeiculosKm.toFixed(2) + '%'}
                    progresso={porcentagemVeiculosKm}
                />
                <ResumoCard
                    titulo="Veículos com +5 anos"
                    valor={relatorio.totalVeiculosComCincoAnos || 0}
                    icone="fa fa-hourglass-half"
                    cor="bg-primary"
                    descricao={`Porcentagem da Frota`}
                    isLoading={loading}
                    valorDescricao={porcentagemVeiculosVelhos.toFixed(2) + '%'}
                    progresso={porcentagemVeiculosVelhos}
                />

            </div>

            {/* 📊 Gráficos */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                <BarChart title="Veículos por Filial" data={filial} horizontal loading={loading} onSelect={(filial) => abrirModal("filial", filial)} />
                <DonutChart title="Veículos por Tipo" data={tipo} loading={loading} onSelect={(tipo) => abrirModal("tipo", tipo)} />
                <BarChart title="Veículos por Fabricante" data={fabricante} loading={loading} onSelect={(fabricante) => abrirModal("fabricante", fabricante)} />
                <BarChart title="Veículos por Centro de Custo" data={centroCusto} loading={loading} onSelect={(centroCusto) => abrirModal("centroCusto", centroCusto)} />
                <BarChart title="Idade da Frota (anos)" data={idade} loading={loading} onSelect={(idade) => abrirModal("idade", idade)} />

                <StackedBarChart
                    title="Distribuição da Frota por Faixa Etária e Filial"
                    data={relatorio.distribuicaoFaixaEtariaPorFilial} loading={loading}
                    onSelect={(filial, faixa) =>
                        abrirModal("faixaEtariaFilial", filial, faixa)
                    }
                />

            </div>

            <TabelaVeiculos veiculos={relatorio.listaVeiculos} />
            <Dialog
                header="Veículos"
                onHide={() => setModalAberto(false)}
                visible={modalAberto}
                className="w-[90%]"
                blockScroll
            >
                <TabelaVeiculos
                    veiculos={filtrarVeiculos(relatorio.listaVeiculos, filtro)}
                />
            </Dialog>


        </div>
    );
}

export default RelatorioFrota;

function mapToSeries(map) {
    if (!map) return { labels: [], series: [] };

    return {
        labels: Object.keys(map),
        series: Object.values(map)
    };
}

const COLORS = [
    "#2563EB", // blue-600
    "#16A34A", // green-600
    "#F59E0B", // amber-500
    "#DC2626", // red-600
    "#7C3AED", // violet-600
    "#0891B2", // cyan-600
    "#EA580C"  // orange-600
];

function BarChart({ title, data, horizontal, loading, onSelect }) {
    return (
        <div className="surface-card p-4 min-h-[320px]">
            <h3 className="font-display font-semibold mb-3 text-foreground">{title}</h3>
            {loading ?

                <Loading />
                :
                <Chart
                    type="bar"
                    height={320}
                    series={[
                        {
                            name: "Quantidade",
                            data: data.series
                        }
                    ]}
                    options={{
                        chart: {
                            toolbar: { show: true },
                            animations: {
                                enabled: true,
                                easing: "easeinout",
                                speed: 800
                            },
                            events: {
                                dataPointSelection: (event, chartContext, config) => {
                                    const label = data.labels[config.dataPointIndex];
                                    onSelect?.(label);
                                }
                            }
                        },
                        plotOptions: {
                            bar: {
                                horizontal: horizontal,
                                borderRadius: 1,
                                distributed: true
                            }
                        },
                        colors: COLORS,
                        xaxis: {
                            categories: data.labels,
                        },
                        tooltip: {
                            theme: "light",
                            y: {
                                formatter: val => `${val} veículos`
                            }
                        },
                        dataLabels: { enabled: false },
                        grid: {
                            borderColor: "#E5E7EB"
                        },
                        legend: { show: false }
                    }}
                />
            }
        </div>
    );
}

function DonutChart({ title, data, loading, onSelect }) {
    return (
        <div className="surface-card p-4 min-h-[320px]">
            <h3 className="font-display font-semibold mb-3 text-foreground">{title}</h3>
            {loading ?
                <Loading />
                :
                <Chart
                    type="donut"
                    height={320}
                    series={data.series}
                    options={{
                        chart: {
                            events: {
                                dataPointSelection: (event, chartContext, config) => {
                                    const label = data.labels[config.dataPointIndex];
                                    onSelect?.(label);
                                }
                            }
                        },
                        labels: data.labels,
                        colors: COLORS,
                        legend: {
                            position: "bottom",
                            fontSize: "13px"
                        },
                        tooltip: {
                            y: {
                                formatter: (val, opts) => {
                                    const total = opts.globals.seriesTotals.reduce((a, b) => a + b, 0);
                                    const percent = ((val / total) * 100).toFixed(1);
                                    return `${val} veículos (${percent}%)`;
                                }
                            }
                        },
                        plotOptions: {
                            pie: {
                                donut: {
                                    size: "65%",
                                    labels: {
                                        show: true,
                                        total: {
                                            show: true,
                                            label: "Total",
                                            formatter: w =>
                                                w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                                        }
                                    }
                                }
                            }
                        }
                    }}
                />
            }
        </div>
    );
}

function LineChart({ title, data, loading, onSelect }) {
    return (
        <div className="surface-card p-4 min-h-[320px]">
            <h3 className="font-display font-semibold mb-3 text-foreground">{title}</h3>
            {loading ?
                <Loading />
                :
                <Chart
                    type="line"
                    height={320}
                    series={[
                        {
                            name: "Quantidade",
                            data: data.series
                        }
                    ]}
                    options={{
                        chart: {
                            events: {
                                dataPointSelection: (event, chartContext, config) => {
                                    const label = data.labels[config.dataPointIndex];
                                    onSelect?.(label);
                                }
                            }
                        },
                        colors: ["#2563EB"],
                        stroke: {
                            curve: "smooth",
                            width: 3
                        },
                        markers: {
                            size: 5
                        },
                        xaxis: {
                            categories: data.labels
                        },
                        tooltip: {
                            y: {
                                formatter: val => `${val} veículos`
                            }
                        },
                        grid: {
                            borderColor: "#E5E7EB"
                        }
                    }}
                />
            }
        </div>
    );
}

function buildStackedSeries(data) {
    if (!data || Object.keys(data).length === 0) {
        return { filiais: [], series: [] };
    }

    const filiais = Object.keys(data);
    const faixas = ["0-2", "3-5", "6-10", "10+"];

    const series = faixas.map(faixa => ({
        name: faixa,
        data: filiais.map(filial => data[filial]?.[faixa] || 0)
    }));

    return { filiais, series };
}

function StackedBarChart({ title, data, loading, onSelect }) {
    const { filiais, series } = buildStackedSeries(data);

    return (
        <div className="surface-card p-4 min-h-[320px]">
            <h3 className="font-display font-semibold mb-3 text-foreground">{title}</h3>
            {loading ?
                <Loading />
                :
                <Chart
                    type="bar"
                    height={350}
                    series={series}
                    options={{
                        chart: {
                            stacked: true,
                            toolbar: { show: true },
                            events: {
                                dataPointSelection: (event, chartContext, config) => {
                                    const filial = filiais[config.dataPointIndex];
                                    const faixa = series[config.seriesIndex].name;

                                    onSelect?.(filial, faixa);
                                }
                            }
                        },
                        plotOptions: {
                            bar: {
                                horizontal: false,
                                borderRadius: 6
                            }
                        },
                        colors: ["#16A34A", "#2563EB", "#F59E0B", "#DC2626"],
                        xaxis: {
                            categories: filiais,
                            labels: {
                                rotate: -30
                            }
                        },
                        yaxis: {
                            title: {
                                text: "Quantidade de veículos"
                            }
                        },
                        tooltip: {
                            shared: true,
                            intersect: false,
                            y: {
                                formatter: val => `${val} veículos`
                            }
                        },
                        legend: {
                            position: "top"
                        },
                        dataLabels: {
                            enabled: false
                        }
                    }}
                />
            }
        </div>
    );
}